module.exports = __webpack_public_path__ + "img/6.1d4c8078.png";